import { ContextUrl } from '../../common/utils/ContextUrl';
import { SiteHelper } from '../../common/utils/SiteHelper';
import AdaApi from '../../common/api/adaAPI';
import Preloader from '../Preloader';
import queryString from 'query-string';
import objectassign from 'core-js/fn/object/assign';

const TokenLogin = (element) => {

    const cookieExpires = window.hubConfig.loginCookieExpires || 30;
    const tokenParamName = window.hubConfig.loginUrlParam || 'lww_st';
    const isIntranetSite = SiteHelper.isIntranetSite();

    const qs = queryString.parse(window.location.search);
    const token = qs[tokenParamName];

    const process = qs && token;

    if (!process || isIntranetSite) {
        return;
    }

    const api = new AdaApi();

    const loader = new Preloader();
    loader.show();

    const hideLoader = () => {
        loader.hide();
    };

    const getRequiredQueryString = () => {
        const new_qs = {};
        objectassign(new_qs, qs);
        delete new_qs[tokenParamName];
        delete new_qs['contextUrl'];
        return queryString.stringify(new_qs);
    };

    const getUrlWithoutQuery = () => {
        const url = window.location.origin + window.location.pathname;
        return url;
    };

    api.loginUserByToken(token)
        .then(response => {
            hideLoader();

            //http://devvm-journals.lww.com/clinorthop/pages/default.aspx?sessionEnd=true&contextUrl=asdf&lww_st=token

            //init the new cookie reader
            window.hubCookie.set(response.data, { expires: cookieExpires });
            let returnUrl = ContextUrl.get(window.location.search) || getUrlWithoutQuery();
            const q = getRequiredQueryString();
            if (q) {
                returnUrl = `${returnUrl}?${q}`;
            }
            window.location = returnUrl;
        })
        .catch(error => {
            //TODO: Need to handle 401 and 500. Is it better to show a modal with a message? sending to the login page will require passing some data to show appropriate message

            //cookie is not valid. So, remove it.
            window.hubCookie.unset();

            //redirect the user to the login page with the current URL as the context URL
            let qs = ContextUrl.set(window.location.search);
            const parsed = queryString.parse(qs);
            delete parsed[tokenParamName];
            qs = queryString.stringify(parsed);
            window.location = `${window.hubConfig.loginUrl}?${qs}`;
        });
}


export default TokenLogin;


// WEBPACK FOOTER //
// ./src/nams2020/webparts/TokenLogin/index.js